<div class="datetime-picker" [ngClass]="{ 'datetime-picker--col': !options.inlineDatePicker }">
	<div
		*ngIf="!options.hideDatepicker"
		class="datetime-picker__grp"
		[popover]="!disabled ? calendarContent : null"
		(onShown)="onDateShown(calendarContent); popoverVisible = true"
		(onHidden)="onDateHidden(); popoverVisible = false"
		[outsideClick]="true"
		[placement]="options.placement">
		<label [attr.for]="options.primaryId" *ngIf="!!options.labelDatePicker">{{ options.labelDatePicker }}</label>

		<div class="datepicker" [class.is-disabled]="disabled">
			<button
				type="button"
				class="btn btn-icon btn-icon--datepicker def-focus"
				[title]="'lup.a11y.open_datepicker' | translate"
				(blur)="onTouch($event)"
				[disabled]="disabled">
				<lu-icon icon="lu-calendar"></lu-icon>
			</button>

			<input
				#dateInput
				[attr.aria-invalid]="!!ngControl.errors"
				type="text"
				[attr.id]="options.primaryId"
				autocomplete="off"
				class="datepicker__control"
				[ngClass]="
					isValid() || (ngControl.control['errors'] && ngControl.control['errors'].primaryRequiredMessage)
						? 'valid'
						: 'is-invalid'
				"
				[disabled]="disabled"
				[required]="options.required"
				[placeholder]="options.placeholderFrom || (options.dateFormat | uppercase)"
				[ngModel]="datetimePrimary | date: options.dateFormat"
				(blur)="onTouch($event)"
				(change)="onInputChange($event, DATE_TYPES.PRIMARY)"
				[readonly]="readonly" />

			<span class="ddm-state-icon">
				<lu-icon
					id="clearButtonIcon"
					(click)="clearSelection($event, dateInput)"
					(keydown.enter)="clearSelection($event, dateInput)"
					(keydown.space)="clearSelection($event, dateInput)"
					role="button"
					[attr.aria-label]="'lup.a11y.select.clear_selected_item_label' | translate"
					tabindex="0"
					[type]="LuIconType.REGULAR"
					icon="lu-clear"
					*ngIf="
						!disabled && ((!!ngControl.value && !!ngControl.errors) || (datetimePrimary && options.displayClearButton))
					"></lu-icon>
				<lu-icon icon="lu-chevron-down" [ngClass]="{ 'fa-rotate-180': popoverVisible }"></lu-icon>
			</span>

			<p
				class="form-error"
				role="alert"
				*ngIf="options.required && ngControl.control['errors'] && ngControl.control['errors'].primaryRequiredMessage">
				{{ ngControl.control['errors'].primaryRequiredMessage | translate }}
			</p>
		</div>
	</div>

	<div class="datetime-picker__grp" [ngClass]="options.timepickerColsClass" *ngIf="!options.hideTimepicker">
		<label [attr.for]="options.primaryTimePickerId" *ngIf="!!options.labelTimePicker">{{
			options.labelTimePicker
		}}</label>

		<div class="timepicker" [class.is-disabled]="disabled" dropdown>
			<timepicker
				[attr.id]="options.primaryTimePickerId"
				[ngModel]="datetimePrimary"
				(ngModelChange)="onTimeChange($event, DATE_TYPES.PRIMARY)"
				[disabled]="disabled"
				[showMinutes]="options.timeOptions.SHOW_MINUTES"
				[showSeconds]="options.timeOptions.SHOW_SECONDS"
				[hourStep]="options.timeOptions.HOUR_STEP"
				[minuteStep]="options.timeOptions.MINUTE_STEP"
				[secondsStep]="options.timeOptions.SECOND_STEP"
				[min]="options.minValue"
				[max]="options.maxValue"></timepicker>
			<button
				class="btn btn-icon btn-icon--timepicker"
				type="button"
				dropdownToggle
				[title]="'lup.a11y.datetime_picker.open_timepicker' | translate">
				<lu-icon [type]="LuIconType.REGULAR" icon="clock"></lu-icon>
			</button>

			<ul
				*dropdownMenu
				class="dropdown-menu timepicker__dropdown"
				role="menu"
				[attr.aria-labelledby]="options.primaryTimePickerId">
				<li *ngFor="let item of time" (click)="updateTime(item, DATE_TYPES.PRIMARY)" tabindex="0">{{ item }}</li>
			</ul>
		</div>
	</div>
</div>
<div
	class="datetime-picker"
	[ngClass]="{ 'datetime-picker--col': !options.inlineDatePicker }"
	*ngIf="options.dateRange">
	<div
		class="datetime-picker__grp"
		[popover]="!disabled ? secondaryCalendarContent : null"
		(onShown)="onDateShown(secondaryCalendarContent)"
		(onHidden)="onDateHidden()"
		[outsideClick]="true"
		[placement]="options.placement">
		<label [attr.for]="options.secondaryId">{{ options.labelTimePickerTo }}</label>

		<div class="datepicker" [class.is-disabled]="disabled">
			<button
				type="button"
				class="btn btn-icon btn-icon--datepicker def-focus"
				[title]="'lup.a11y.open_datepicker' | translate"
				(blur)="onTouch($event)"
				[disabled]="disabled">
				<lu-icon icon="lu-calendar"></lu-icon>
			</button>
			<input
				type="text"
				[attr.id]="options.secondaryId"
				[attr.aria-invalid]="!!ngControl.errors"
				autocomplete="off"
				class="datepicker__control"
				*ngIf="options.dateRange"
				[required]="options.required"
				[ngClass]="
					isValid() || (ngControl.control['errors'] && ngControl.control['errors'].secondaryRequiredMessage)
						? 'valid'
						: 'is-invalid'
				"
				[disabled]="disabled"
				[placeholder]="options.placeholderTo || (options.dateFormat | uppercase)"
				[ngModel]="datetimeSecondary | date: options.dateFormat"
				(blur)="onTouch($event)"
				(change)="onInputChange($event, DATE_TYPES.SECONDARY)"
				[readonly]="readonly" />

			<p
				class="form-error"
				role="alert"
				*ngIf="options.required && ngControl.control['errors'] && ngControl.control['errors'].secondaryRequiredMessage">
				{{ ngControl.control['errors'].secondaryRequiredMessage | translate }}
			</p>
		</div>
	</div>

	<div class="datetime-picker__grp" [ngClass]="options.timepickerColsClass" *ngIf="!options.hideTimepicker">
		<label [attr.for]="options.secondaryTimePickerId">{{ options.labelTimePickerTo }}</label>
		<div class="timepicker" dropdown>
			<timepicker
				class="timepicker datarange-timepicker"
				[ngModel]="datetimeSecondary"
				[attr.id]="options.secondaryTimePickerId"
				(ngModelChange)="onTimeChange($event, DATE_TYPES.SECONDARY)"
				[disabled]="disabled"
				[showMinutes]="options.timeOptions.SHOW_MINUTES"
				[showSeconds]="options.timeOptions.SHOW_SECONDS"
				[hourStep]="options.timeOptions.HOUR_STEP"
				[minuteStep]="options.timeOptions.MINUTE_STEP"
				[secondsStep]="options.timeOptions.SECOND_STEP"
				[min]="options.minValue"
				[max]="options.maxValue"></timepicker>
			<button
				class="btn btn-icon btn-icon--timepicker"
				type="button"
				dropdownToggle
				[title]="'lup.a11y.datetime_picker.open_timepicker' | translate">
				<lu-icon [type]="LuIconType.REGULAR" icon="clock"></lu-icon>
			</button>

			<p
				class="form-error"
				role="alert"
				*ngIf="options.required && ngControl.control['errors'] && ngControl.control['errors'].secondaryRequiredMessage">
				{{ ngControl.control['errors'].secondaryRequiredMessage | translate }}
			</p>

			<p
				class="form-error"
				role="alert"
				*ngIf="ngControl.control['errors'] && ngControl.control['errors'].invalidRange">
				{{ 'learningpaths.invalid_due_date_format' | translate }}
			</p>

			<ul
				*dropdownMenu
				class="dropdown-menu timepicker__dropdown"
				role="menu"
				[attr.aria-labelledby]="options.secondaryTimePickerId">
				<li *ngFor="let item of time" (click)="updateTime(item, DATE_TYPES.SECONDARY)" tabindex="0">{{ item }}</li>
			</ul>
		</div>
	</div>
</div>

<ng-template #calendarContent>
	<div *ngIf="!showTimePickerPrimaryToggle">
		<bs-datepicker-inline
			[bsValue]="datetimePrimary"
			[isDisabled]="disabled"
			[minDate]="options.minValue"
			[maxDate]="options.maxValue"
			[bsConfig]="{ showWeekNumbers: false, customTodayClass: 'current-day' }"
			(bsValueChange)="onDateChange($event, DATE_TYPES.PRIMARY)">
		</bs-datepicker-inline>
	</div>
</ng-template>

<ng-template #secondaryCalendarContent>
	<div *ngIf="options.dateRange && !showTimePickerSecondaryToggle">
		<bs-datepicker-inline
			class="datarange-datepicker"
			[bsValue]="datetimeSecondary"
			[isDisabled]="disabled"
			[minDate]="options.minValue"
			[maxDate]="options.maxValue"
			[bsConfig]="{ showWeekNumbers: false, customTodayClass: 'current-day' }"
			(bsValueChange)="onDateChange($event, DATE_TYPES.SECONDARY)">
		</bs-datepicker-inline>
	</div>
</ng-template>
